import { FC } from "react";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { useAppSelector } from "store";
import { useCapabilities } from "store/capability-hooks";
import { selectHasSubmissionsForPageId, selectIsUnassessablePage } from "store/selectors";

interface UnassessablePageSubmissionsBannerProps {
  pageId: string;
}

export const UnassessablePageSubmissionsBanner: FC<UnassessablePageSubmissionsBannerProps> = ({
  pageId,
}) => {
  const { canAuthorSection } = useCapabilities();
  const isUnassessable = useAppSelector((s) => selectIsUnassessablePage(s, pageId));
  const hasSubmissions = useAppSelector((s) => selectHasSubmissionsForPageId(s, pageId));

  const showUnassessablePageSubmissionsBanner =
    canAuthorSection && hasSubmissions && isUnassessable;

  if (!showUnassessablePageSubmissionsBanner) {
    return null;
  }

  return <Banner kind="warning">{t("warning.unassessable_page_submissions")}</Banner>;
};
